module.exports = __webpack_public_path__ + "assets/img/banner-ph-mob.ffd17d4c.webp";